import { render, staticRenderFns } from "./my-currency-input.vue?vue&type=template&id=43756d6a&"
import script from "./my-currency-input.vue?vue&type=script&lang=js&"
export * from "./my-currency-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports